module.exports = __webpack_public_path__ + "img/achievements.9097cda8.jpg";